'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _AccordionWidget = require('../AccordionWidget');

var _AccordionWidget2 = _interopRequireDefault(_AccordionWidget);

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _BonusCode = require('./BonusCode');

var _BonusCode2 = _interopRequireDefault(_BonusCode);

var _tgCoreComponents = require('tg-core-components');

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

var _Money = require('../../components/Money');

var _Money2 = _interopRequireDefault(_Money);

var _states = require('./states');

var _types = require('./types');

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALEACC_BONUS_CLAIM_STATE = ['Initiated', 'PreClaimed'];
var ALEACC_BONUS_REJECT_STATE = ['Initiated', 'PreClaimed', 'Pending', 'PreWager'];
var ALEACC_BONUS_ACTION_STATE = [].concat(ALEACC_BONUS_CLAIM_STATE, ALEACC_BONUS_REJECT_STATE);

var BonusAction = function BonusAction(_ref) {
  var bonus = _ref.bonus,
      onClaimBonus = _ref.onClaimBonus,
      onRejectBonus = _ref.onRejectBonus;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoadingClaim = _useState2[0],
      setIsLoadingClaim = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoadingReject = _useState4[0],
      setIsLoadingReject = _useState4[1];

  var claimBonus = function claimBonus(e) {
    onClaimBonus(bonus, function (isLoading) {
      return setIsLoadingClaim(isLoading);
    }, e);
  };

  var rejectBonus = function rejectBonus(e) {
    onRejectBonus(bonus, function (isLoading) {
      return setIsLoadingReject(isLoading);
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { className: 'actions' },
    (ALEACC_BONUS_CLAIM_STATE.includes(bonus.State) || bonus.Type === 'Deposit') && _react2.default.createElement(
      _Button2.default,
      {
        className: 'button primary small',
        onClick: claimBonus,
        isLoading: isLoadingClaim },
      _react2.default.createElement(_Translate2.default, { id: 'action.bonus.claim', defaultMessage: 'Claim' })
    ),
    ALEACC_BONUS_REJECT_STATE.includes(bonus.State) && _react2.default.createElement(
      _Button2.default,
      {
        className: 'button secondary small',
        onClick: rejectBonus,
        isLoading: isLoadingReject },
      _react2.default.createElement(_Translate2.default, { id: 'action.bonus.reject', defaultMessage: 'Reject' })
    )
  );
};

var BonusActionFT = function BonusActionFT(_ref2) {
  var bonus = _ref2.bonus,
      onClaimBonus = _ref2.onClaimBonus;

  // Atm it's only fasttrack that supports actions.
  if (bonus.Provider !== 'fasttrack') return null;

  // Expired bonuses has no actions
  if (bonus.State === 'Expired') return null;

  // FTType 1 - Pending Bonus
  // Claim bonus and redirect to game of present.
  if (bonus.FTType === 1) {
    // consume endpoint provided by FT
    return _react2.default.createElement(
      _Button2.default,
      {
        onClick: function onClick(e) {
          return onClaimBonus(bonus, null, e);
        },
        className: 'button primary action wide ' + (bonus.IsLocked && 'locked') },
      _react2.default.createElement(_Translate2.default, { id: 'action.bonus.type1', defaultMessage: 'Action type1' })
    );
  }

  // FTType 2 - Pending Deposit Bonus
  // Send bonus to cashier and redirect to game of present.
  if (bonus.FTType === 2) {
    return _react2.default.createElement(
      _Button2.default,
      {
        onClick: function onClick(e) {
          return onClaimBonus(bonus, null, e);
        },
        className: 'button primary action wide ' + (bonus.IsLocked && 'locked') },
      _react2.default.createElement(_Translate2.default, { id: 'action.bonus.type2', defaultMessage: 'Action type2' })
    );
  }

  // FTType 3 - Locked Bonus
  // Send bonus to cashier and redirect back to bonuses
  if (bonus.FTType === 3) {
    return _react2.default.createElement(
      _Button2.default,
      {
        onClick: function onClick(e) {
          return onClaimBonus(bonus, null, e);
        },
        className: 'button primary action wide ' + (bonus.IsLocked && 'locked') },
      !!bonus.IsLocked && _react2.default.createElement(_Translate2.default, {
        id: 'action.bonus.type3-locked',
        defaultMessage: 'Action type3 locked'
      }),
      !bonus.IsLocked && _react2.default.createElement(_Translate2.default, { id: 'action.bonus.type3', defaultMessage: 'Action type3' })
    );
  }

  return null;
};

var BonusWidget = function BonusWidget(_ref3) {
  var bonuses = _ref3.bonuses,
      handleBonusCodeSubmit = _ref3.handleBonusCodeSubmit,
      onClaimBonus = _ref3.onClaimBonus,
      onRejectBonus = _ref3.onRejectBonus;

  var bonusList = { active: null, available: null, finished: null };

  var bonusMapping = {
    InPlay: 'active',
    Active: 'active',
    Initiated: 'available',
    PreClaimed: 'available',
    PreWager: 'available',
    Expired: 'finished',
    Rejected: 'finished',
    Finished: 'finished',
    Canceled: 'finished',
    FinishedNoGains: 'finished',
    AdminCanceled: 'finished'
  };

  Object.keys(bonusList).forEach(function (bonusState) {
    var listData = bonuses.filter(function (bonus) {
      return bonusMapping[bonus.State] === bonusState || bonus.Type === 'Deposit' && bonusState === 'available';
    });

    bonusList[bonusState] = listData.map(function (item) {
      var wageringRequirement = bonusState === 'available' ? item.PreWagerRequirement : item.WageringRequirment;
      var wageringRequirementRemaining = bonusState === 'available' ? item.PreWagerRequirementRemaining : item.WageringRequirmentRemaining;

      var info = [[_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          item.Name || item.Description
        )
      ), _react2.default.createElement(
        'div',
        null,
        (0, _states.getBonusState)(item.State)
      )], [item.Amount && _react2.default.createElement(
        'div',
        { className: 'amount' },
        item.Type.toLowerCase() == 'freespins' ? _react2.default.createElement(_reactIntl.FormattedNumber, { value: item.Amount, style: 'decimal' }) : _react2.default.createElement(_Money2.default, { value: item.Amount, currency: item.Currency })
      ), (0, _types.getBonusType)(item.Type)]];

      // Add bonus actions to not expired Fasttrack bonuses
      if (item.Provider === 'fasttrack' && item.State !== 'Expired') info.push(_react2.default.createElement(BonusActionFT, { bonus: item, onClaimBonus: onClaimBonus }));
      // Add bonus actions to post claim bonuses from Aleacc
      else if (item.Provider !== 'fasttrack' && ALEACC_BONUS_ACTION_STATE.includes(item.State) || item.Type === 'Deposit') info.push(_react2.default.createElement(BonusAction, {
          bonus: item,
          onClaimBonus: onClaimBonus,
          onRejectBonus: onRejectBonus
        }));

      var detail = [[_react2.default.createElement(
        'span',
        null,
        'ID: #',
        item.Id
      ), _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Translate2.default, { id: 'label.initiated.bonus', defaultMessage: 'Initiated' }),
        _react2.default.createElement(
          'span',
          null,
          ':'
        ),
        ' ',
        _react2.default.createElement(_reactIntl.FormattedDate, {
          value: item.Initiated,
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        })
      )], [Boolean(wageringRequirement) && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Translate2.default, {
          id: 'label.bonus_table_wagering',
          defaultMessage: 'Wagering'
        }),
        _react2.default.createElement(
          'span',
          null,
          ':'
        ),
        ' ',
        _react2.default.createElement(
          'span',
          null,
          (100 - wageringRequirementRemaining / wageringRequirement * 100).toFixed(2),
          '% / 100%'
        )
      ), _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Translate2.default, { id: 'label.expires.bonus', defaultMessage: 'Expires' }),
        _react2.default.createElement(
          'span',
          null,
          ':'
        ),
        ' ',
        _react2.default.createElement(_reactIntl.FormattedDate, {
          value: item.Expires,
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        })
      )]];

      info.push([_react2.default.createElement('div', {
        className: 'disclaimer',
        dangerouslySetInnerHTML: {
          __html: item.content && item.content.disclaimer && (0, _marked2.default)(item.content.disclaimer || '') || item.promotion && item.promotion.shortDisclaimer
        }
      })]);

      return {
        id: item.Id,
        info: info,
        detail: detail
      };
    });
  });

  var menu = {
    identifier: 'account-history',
    items: [{
      name: _react2.default.createElement(_Translate2.default, { id: 'label.active', defaultMessage: 'Activate' }),
      content: _react2.default.createElement(_tgCoreComponents.List, { data: bonusList['active'], noData: 'list.no_data.active' })
    }, {
      name: _react2.default.createElement(_Translate2.default, { id: 'label.available', defaultMessage: 'Available' }),
      content: _react2.default.createElement(_tgCoreComponents.List, { data: bonusList['available'], noData: 'list.no_data.available' })
    }, {
      name: _react2.default.createElement(_Translate2.default, { id: 'label.finished', defaultMessage: 'Finished' }),
      content: _react2.default.createElement(_tgCoreComponents.List, { data: bonusList['finished'], noData: 'list.no_data.finished' })
    }, {
      name: _react2.default.createElement(_Translate2.default, { id: 'label.bonus_code', defaultMessage: 'Bonus code' }),
      content: _react2.default.createElement(_BonusCode2.default, { handleSubmit: handleBonusCodeSubmit })
    }]
  };

  var items = menu.items.map(function (item, i) {
    return {
      header: _react2.default.createElement(
        'div',
        { className: 'profile-item-header' },
        _react2.default.createElement(
          'div',
          { className: 'title-text' },
          item.name
        )
      ),
      content: _react2.default.createElement(
        'div',
        null,
        item.content
      ),
      key: i
    };
  });

  var initialExpandedIndex = bonusList['active'].length > 0 && bonusList['available'].length == 0 ? 0 : bonusList['available'].length > 0 ? 1 : null;

  return _react2.default.createElement(_AccordionWidget2.default, {
    items: items,
    initialExpandedIndex: initialExpandedIndex
  });
};

exports.default = BonusWidget;